<template>
    <div class="dev">
        <img src="@/assets/images/dev.png" alt="">
    </div>
</template>

<script>
    export default {
        name: "dev"
    }
</script>

<style scoped lang="less">
.dev{
    width:133px;height:141px;margin:50px auto 0;
}
</style>